import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import PropTypes from 'prop-types';

/**
 * Component that protects routes by ensuring user is authenticated
 * Redirects unauthenticated users to the login page
 * NON-BLOCKING: Renders children immediately while checking auth in background
 */
export default function AuthProtectedRoute({ children }) {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthChecked(true);
    });
    
    return () => unsubscribe();
  }, []);

  // Not logged in and auth check complete - redirect to sign in
  if (authChecked && !user) {
    return <Navigate to="/" replace />;
  }
  
  // Render children immediately (non-blocking)
  // If user is not yet determined, children will still render
  // If user becomes null after check, redirect will happen
  return children;
} 

AuthProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
}; 